import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContentDialog,
  SelectItem,
  SelectTriggerIcon,
  SelectValue,
} from "@/components/ui/select";
import StatusDot from "@/ui/StatusDot";

export default function TaskStatusSelect(props) {
  return (
    <Select {...props}>
      <SelectTriggerIcon className="border-none bg-transparent">
        <SelectValue placeholder="Select status" className="" />
      </SelectTriggerIcon>
      <SelectContentDialog className="[&_*[role=option]>span>svg]:shrink-0 [&_*[role=option]>span>svg]:text-muted-foreground/80 [&_*[role=option]>span]:end-2 [&_*[role=option]>span]:start-auto [&_*[role=option]>span]:flex [&_*[role=option]>span]:items-center [&_*[role=option]>span]:gap-2 [&_*[role=option]]:pe-8 [&_*[role=option]]:ps-2">
        <SelectItem value="to_do">
          <Badge variant="gray" className="flex items-center gap-2">
            <StatusDot className="text-gray-400" />
            <span className="truncate">To Do</span>
          </Badge>
        </SelectItem>

        <SelectItem value="in_progress">
          <Badge variant="ongoing" className="flex items-center gap-2">
            <StatusDot className="text-[var(--blue-500)]" />
            <span className="truncate">In Progress</span>
          </Badge>
        </SelectItem>
        <SelectItem value="done">
          <Badge variant="done" className="flex items-center gap-2">
            <StatusDot className="text-[var(--emerald-600)]" />
            <span className="truncate">Done</span>
          </Badge>
        </SelectItem>
      </SelectContentDialog>
    </Select>
  );
}
